import { Navigate, Route, Routes } from 'react-router';
import { AdminScreen } from './admin/AdminScreen';
import { InviteScreen } from './auth/InviteScreen';
import { ResetPasswordScreen } from './auth/ResetPasswordScreen';
import { SignInScreen } from './auth/SignInScreen';
import { SignUpScreen } from './auth/SignUpScreen';
import { ModuleRoute } from './ModuleRoute';
import { ModulesScreen } from './modules/ModulesScreen';
import { RequireSession } from './RequireSession';
import { SettingsScreen } from './settings/SettingsScreen';
import { AppShell } from './shell/AppShell';
import { TodayScreen } from './today/TodayScreen';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignInScreen />} />
      <Route path="/sign-up" element={<SignUpScreen />} />
      <Route path="/invite/:token" element={<InviteScreen />} />
      <Route path="/reset/:token" element={<ResetPasswordScreen />} />
      <Route element={<RequireSession />}>
        <Route element={<AppShell />}>
          <Route index element={<TodayScreen />} />
          <Route path="modules" element={<ModulesScreen />} />
          <Route path="settings" element={<SettingsScreen />} />
          <Route path="admin" element={<AdminScreen />} />
          <Route path="m/:moduleId/*" element={<ModuleRoute />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
